// extracted by mini-css-extract-plugin
export default {"pageTitle":"pageTitle_pageTitle__vws++"};